import { stringMasterAchievement } from './helpers';

export default stringMasterAchievement(3, 'G', 23);
